import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { FunctionComponent } from 'react';

export interface StepProps {
    header: JSX.Element;
    body: JSX.Element;
    footer: JSX.Element;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            height: '100%'
        },
        horizontalPaddings: {
            paddingLeft: 32,
            paddingRight: 32,
            [theme.breakpoints.down('sm')]: {
                paddingLeft: 16,
                paddingRight: 16
            }
        },
        headerContainer: {
            paddingTop: 37,
            paddingBottom: 18,
            [theme.breakpoints.down('sm')]: {
                paddingTop: 24,
                paddingBottom: 12
            }
        },
        bodyContainer: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            height: '100%',
            paddingTop: 30
        },
        bodyBottomSpace: {
            height: 1,
            border: '1px solid white',
            marginTop: 37,
            [theme.breakpoints.down('sm')]: {
                marginTop: 24
            }
        },
        footerContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: 24,
            paddingBottom: 24,
            borderTop: '1px solid #D4D4D4',
            [theme.breakpoints.down('sm')]: {
                paddingTop: 12,
                paddingBottom: 12
            }
        }
    })
);

export const Step: FunctionComponent<StepProps> = props => {
    const classes = useStyles(props);
    return (
        <Box className={classes.container}>
            <Box className={clsx(classes.headerContainer, classes.horizontalPaddings)}>{props.header}</Box>
            <OverlayScrollbarsComponent style={{ height: '100%' }}>
                <Box className={clsx(classes.bodyContainer, classes.horizontalPaddings)}>
                    {props.body}
                    <Box className={classes.bodyBottomSpace} />
                </Box>
            </OverlayScrollbarsComponent>
            <Box className={clsx(classes.footerContainer, classes.horizontalPaddings)}>{props.footer}</Box>
        </Box>
    );
};

export default Step;
